var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Transition from 'react-transition-group/Transition';
import { reDraw } from '../../../helpers/common';
import { propBool, propNumber } from '../../../helpers/custom-prop-types';
const ModalHoc = (ChildComponent) => {
    const ModalHocInner = (props) => {
        const { isShow, timeout } = props, addProp = __rest(props, ["isShow", "timeout"]);
        return (_jsx(Transition, Object.assign({ in: isShow, mountOnEnter: true, onEnter: reDraw, onExit: reDraw, timeout: timeout, unmountOnExit: true }, { children: (state) => _jsx(ChildComponent, Object.assign({ modalState: state }, addProp)) })));
    };
    ModalHocInner.propTypes = {
        isShow: propBool().isRequired,
        timeout: propNumber(),
    };
    ModalHocInner.defaultProps = {
        timeout: 500,
    };
    return ModalHocInner;
};
export default ModalHoc;
